import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsDataManagerObjectClassViewRoute: InvariantJiraRoute = {
	name: 'assets-data-manager-object-class-view',
	path: '/jira/assets/data-manager/object-classes/view/:objectClassId',
	exact: true,
	query: ['tab?'],
};
